// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable babel/camelcase */
import type {
  BookingId,
  Currency,
  ShoppingBasketId,
} from "../../../../../../../../types/primitiveTypes"
import { transport } from "../../../../../../../../services/api/transport"
import type {
  BasketPaymentInbound,
  ShoppingBasketInbound,
  ShoppingBasketPOSTInbound,
  ShoppingBasketOutbound,
  BasketPaymentPayload,
} from "./types"

/**
 * Creates a new or returns an existing shopping basket
 * @param bid
 * @param currency
 * @returns {Promise<*>}
 */
export function fetchShoppingBasket(
  bid: BookingId,
  currency: Currency,
): Promise<ShoppingBasketInbound> {
  return transport(
    "PUT",
    bid,
    `/payments/v1/payments/order`,
    { booking_id: bid },
    {
      currency: currency.toUpperCase(),
    },
  )
}

export const updateShoppingBasket = (
  bid: BookingId,
  basketId: ShoppingBasketId,
  basket: ShoppingBasketOutbound,
): Promise<ShoppingBasketPOSTInbound> =>
  transport("POST", bid, `/payments/v1/payments/order/${basketId}`, { booking_id: bid }, basket)

export const startProcessingPayment = (
  bid: BookingId,
  basketId: ShoppingBasketId,
  payload: BasketPaymentPayload,
): Promise<BasketPaymentInbound> =>
  transport(
    "POST",
    bid,
    `/payments/v1/payments/order/${basketId}/payment`,
    { booking_id: bid },
    payload,
  )
